export const createFolderErrorCodes = {
  DIRECTORY_NAME_EXISTS: 'Mappenavn finnes allerede',
};
